
import { defineComponent, ref, watch } from "vue";
import ApiService from "@/core/services/ApiService";
import { statusColor, translate } from "@/core/services/HelpersFun";

export default defineComponent({
  name: "view-payment-request-management-details-modal",
  components: {},
  props: {
    requestId: {
      type: String,
    },
  },
  setup(props) {
    const loading = ref(true);
    const details = ref();

    const getDetails = () => {
      loading.value = true;
      ApiService.query(`/admin/request-payment/${props.requestId}`, {})
        .then(({ data }) => {
          // con
          loading.value = false;
          details.value = data.data.request;
        })
        .catch(() => {
          loading.value = false;
        });
    };

    watch(props, () => {
      getDetails();
    });

    return {
      loading,
      details,
      statusColor,
      translate,
    };
  },
});
